<script setup lang="ts">
import { AlertTriangle, ArrowRight, Hammer, Home, Layers, ShieldCheck, Wrench } from "lucide-vue-next";
import { services } from "@/data/services";
import "@/assets/styles/service.css";

const icons = [Home, ShieldCheck, Wrench, Layers, Hammer, AlertTriangle];
</script>

<template>
  <main class="services">
    <header class="services-header">
      <span class="section-badge">Leistungen</span>
      <h1>Was wir für Ihr Dach tun</h1>
      <p>Wählen Sie eine Leistung aus und erfahren Sie mehr über Umfang, Vorteile und den konkreten Ablauf.</p>
    </header>

    <div class="services-grid">
      <RouterLink
        v-for="(service, index) in services"
        :key="service.slug"
        :to="`/leistungen/${service.slug}`"
        class="service-card"
        :aria-label="`${service.title}: Details ansehen`"
      >
        <div class="service-media">
          <img :src="`/images/services/${service.slug}.png`" :alt="`${service.title} – Dachdecker bei der Arbeit`" loading="lazy" />
        </div>
        <div class="service-icon"><component :is="icons[index]" /></div>
        <h2>{{ service.title }}</h2>
        <p>{{ service.short }}</p>
        <span class="service-more">Mehr erfahren <ArrowRight /></span>
      </RouterLink>
    </div>
  </main>
</template>
